export default "__VITE_ASSET__73a21743__"